export default function SectorsSection() {
  const sectors = [
    {
      title: 'Settore Residenziale',
      description: 'Soluzioni per il risparmio energetico domestico, impianti fotovoltaici residenziali e sistemi di efficientamento per abitazioni private.',
      image: 'https://public.readdy.ai/ai/img_res/0a63eb090568c16b8e70fb6563c685a8.jpg',
      icon: 'ri-home-4-line'
    },
    {
      title: 'Settore Industriale',
      description: 'Strutture metalliche, impianti fotovoltaici industriali e soluzioni integrate per il risparmio energetico di stabilimenti produttivi.',
      image: 'https://readdy.ai/api/search-image?query=large%20industrial%20factory%20building%20with%20extensive%20solar%20panel%20array%20on%20rooftop%20modern%20manufacturing%20facility%20with%20renewable%20energy%20infrastructure%20wide%20angle%20view%20showing%20scale%20of%20photovoltaic%20installation%20professional%20industrial%20photography&width=600&height=400&seq=sector002&orientation=landscape',
      icon: 'ri-factory-line'
    },
    {
      title: 'Settore Commerciale',
      description: 'Forniture e installazioni per centri commerciali, uffici e strutture terziarie con focus su efficienza energetica e sostenibilità.',
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20with%20solar%20panels%20integrated%20into%20facade%20contemporary%20glass%20architecture%20with%20renewable%20energy%20technology%20urban%20business%20district%20setting%20professional%20architectural%20photography%20with%20clean%20lines&width=600&height=400&seq=sector003&orientation=landscape',
      icon: 'ri-store-2-line'
    },
    {
      title: 'Settore Agricolo',
      description: 'Impianti fotovoltaici per aziende agricole, serre e strutture rurali, con soluzioni per l\'autoconsumo e la vendita di energia.',
      image: 'https://readdy.ai/api/search-image?query=agricultural%20farm%20with%20solar%20panel%20installation%20on%20barn%20roof%20rural%20countryside%20setting%20with%20photovoltaic%20system%20for%20sustainable%20farming%20green%20fields%20and%20blue%20sky%20professional%20agricultural%20photography&width=600&height=400&seq=sector004&orientation=landscape',
      icon: 'ri-plant-line'
    }
  ];

  return (
    <section id="sectors" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-6">
            <span className="text-sm font-semibold text-emerald-700">Settori di Attività</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Operiamo in Diversi Settori
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            La nostra esperienza nel <strong>risparmio energetico</strong> e nelle <strong>energie rinnovabili</strong> ci permette di servire clienti in molteplici ambiti
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {sectors.map((sector, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-80 overflow-hidden">
                <img 
                  src={sector.image}
                  alt={sector.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="w-14 h-14 flex items-center justify-center bg-emerald-600 rounded-xl mb-4">
                  <i className={`${sector.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">{sector.title}</h3>
                <p className="text-sm text-gray-200 leading-relaxed">{sector.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
